export default __webpack_public_path__ + "static/media/QFort.e01bbd89.jpg";